import { Review } from '../data'
import { ReviewCard } from './partials/review-card'
import { useReviewsConfig } from '../providers'

export function ReviewsGrid({
  reviews,
  hasNextPage,
  isFetchingNextPage,
  onLoadMore,
  gridType,
  columnCount,
  columnCount780,
  columnCount1200,
}: {
  reviews: Review[]
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
  onLoadMore?: () => void
  gridType?: 'general' | 'masonry'
  columnCount?: number
  columnCount780?: number
  columnCount1200?: number
}) {
  const options = useReviewsConfig()

  const mobileCols = columnCount || options.grid?.columnCount || 1
  const tabletCols = columnCount780 || options.grid?.columnCount780 || Math.min(mobileCols, 2)
  const desktopCols = columnCount1200 || options.grid?.columnCount1200 || Math.min(mobileCols, 4)

  const effectiveGridType = gridType || options.grid?.type
  const isMasonry = effectiveGridType === 'masonry'
  const baseClasses = `grid gap-4 mb-8`

  return (
    <div className="homerunner-reviews-grid w-full">
      <div
        className={`homerunner-reviews-grid-container ${baseClasses}${isMasonry ? ' masonry-grid' : ''}`}
        style={{
          '--masonry-columns-mobile': mobileCols,
          '--masonry-columns-tablet': tabletCols,
          '--masonry-columns-desktop': desktopCols,
          '--grid-columns-mobile': mobileCols,
          '--grid-columns-tablet': tabletCols,
          '--grid-columns-desktop': desktopCols,
        } as React.CSSProperties}
      >
        {reviews.map((review) => (
          <div key={review.id} className="homerunner-reviews-grid-item flex flex-col">
            <ReviewCard review={review} />
          </div>
        ))}
      </div>

      {hasNextPage && (
        <div className="homerunner-reviews-grid-load-more-wrapper">
          <button
            onClick={onLoadMore}
            disabled={isFetchingNextPage}
            className="homerunner-reviews-grid-load-more-button bg-accent"
          >
            {isFetchingNextPage ? 'Loading...' : 'Load More'}
          </button>
        </div>
      )}
    </div>
  )
}
